import { Network, useCreateLoginTokenForCurrentUserInClientMutation } from 'api';
import { useGlobalClient, useNotify, useCurrentUser } from 'hooks';
import { queryString } from 'utilities';
import { AUTH_DOMAIN } from 'settings';
import { ACCESS_KEY } from 'app-constants';

const useConnectAccount = (network: Network) => {
  const client = useGlobalClient();
  const notify = useNotify();
  const currentUser = useCurrentUser();

  if (!client) {
    throw new Error('useConnectAccount requires a client provider');
  }

  const access_key = localStorage.getItem(ACCESS_KEY);
  const commonParams = {
    success_callback_url: `${window.location.origin}${window.location.pathname}${encodeURIComponent(
      window.location.search
    )}`,
    failure_callback_url: `${window.location.origin}${window.location.pathname}${encodeURIComponent(
      window.location.search
    )}`,
  };

  const { mutate: createLoginToken } = useCreateLoginTokenForCurrentUserInClientMutation({
    onError: notify.mutationError,
    onSuccess: ({ createLoginTokenForCurrentUserInClient }) => {
      const params = {
        user_id: currentUser.id,
        token: createLoginTokenForCurrentUserInClient,
        source: 'protected partner sharing',
        ...commonParams,
      };

      initConnect(params);
    },
  });

  function handlePublicConnect() {
    if (!access_key) {
      throw new Error('Access key is required for public connect');
    }

    const params = {
      access_key,
      client_id: client.id,
      source: 'public partner sharing',
      ...commonParams,
    };

    initConnect(params);
  }

  function handleProtectedConnect() {
    createLoginToken({ client_id: client.id });
  }

  function initConnect(params: Record<string, unknown>) {
    window.location.href = `${AUTH_DOMAIN}/connect/${network}?${queryString(params)}`;
  }

  function connect() {
    !currentUser ? handlePublicConnect() : handleProtectedConnect();
  }

  return connect;
};

export default useConnectAccount;
